import React from 'react';

import { Button, ButtonTypes } from '@eika/button';
import { ErrorCard } from '@eika/card';

import useTranslation from '../../../../hooks/useTranslation';

interface Props {
    onClose: () => void;
    onRetry: () => void;
}

const DeleteError: React.FC<Props> = ({ onClose, onRetry }) => {
    const translated = useTranslation();

    return (
        <div className="component-group item-error_wrapper outbox-item__container">
            <ErrorCard
                title={translated.errors.somethingWentWrong}
                description={translated.outbox.deleteApprovalItemFailed}
            >
                <Button buttonType={ButtonTypes.SMALL_NEGATIVE} onClick={onClose}>
                    {translated.cancel}
                </Button>
                <Button buttonType={ButtonTypes.SMALL_POSITIVE} onClick={onRetry}>
                    {translated.tryAgain}
                </Button>
            </ErrorCard>
        </div>
    );
};

export default DeleteError;
